const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/stage'

const config = {
  API_URL,
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || '',
  INTEGRATION_BASE_URL:
    process.env.REACT_APP_INTEGRATION_BASE_URL ||
    `${API_URL}/api/integration/v1`,
  PORTALS_FEED_BASE_URL:
    process.env.REACT_APP_PORTALS_FEED_BASE_URL ||
    `${API_URL}/api/v1/portals/feed`
}

export default config
